  <div class="card login-form text-center m-auto col-md-6 ol-xs-12">
    <div class="card-body">
      <img class="mb-4" src="../../../assets/images/cwfo.png" alt="">
      <label for="inputEmail" class="sr-only">Username</label>
      <input type="email" id="inputEmail" class="form-control mb-1" placeholder="Username" required autofocus name="username" [(ngModel)]="creds.username"> 
      <label for="inputPassword" class="sr-only">Password</label>
      <input type="password" id="inputPassword" class="form-control mb-1" placeholder="Password" required name="password" [(ngModel)]="creds.password">
      <button class="btn btn-lg btn-primary btn-block mt-3" (click)="login()">Sign in</button>
    </div>
  </div>